import React from 'react';
import * as S from './listing-section.styles';

const LoadingListingSection = () => {
  return (
    <S.ListWrap>
      <S.LeftSection>
        <span className="listingImgLoading"></span>
      </S.LeftSection>
      <S.RightSection>
        <div className="dF justifyBetween marginB5">
          <p className="heading loadingShimmer"></p>
          <p className="pricing loadingShimmer"></p>
        </div>
        <div className="dF justifyBetween marginB10">
          <p className="subheading loadingShimmer"></p>
          <p className="dateTag loadingShimmer"></p>
        </div>
        <div className="dF justifyBetween">
          <div>
            <p className="fromto loadingShimmer marginB5"></p>
            <p className="stops loadingShimmer"></p>
          </div>
          <span className="timeTag loadingShimmer"></span>
        </div>
      </S.RightSection>
    </S.ListWrap>
  );
};
export default LoadingListingSection;
